/* Created by Interactive 63 - https://interactive63.com */
/**
 * Formats a saved-at time for the recent-projects cards: relative ("5 minutes ago",
 * "Yesterday") for recent changes, otherwise a date such as "14 Oct 2026" in en-AU format.
 */

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** Describes how long ago `iso` was, relative to `now`. */
export function formatRelativeTime(iso: string, now = new Date()): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return '';
  const elapsed = now.getTime() - then.getTime();
  const relative = new Intl.RelativeTimeFormat('en-AU', { numeric: 'auto' });
  if (elapsed < MINUTE) return 'Just now';
  if (elapsed < HOUR) return relative.format(-Math.floor(elapsed / MINUTE), 'minute');
  if (elapsed < DAY) return relative.format(-Math.floor(elapsed / HOUR), 'hour');
  if (elapsed < 2 * DAY) return 'Yesterday';
  return new Intl.DateTimeFormat('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
    .format(then)
    .replace(/\bSept\b/, 'Sep');
}
